<template>
  <div>
    <h1>Bills</h1>
    <v-data-table
      v-if="bills && bills.length"
      :headers="headers"
      :items="bills"
      hide-actions
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn :to="{ name: 'bill', params: { id: props.item.id } }">{{
              props.item.id
            }}</v-btn>
          </td>
          <td>{{ props.item.billprojection }}</td>
          <td>
            <FileGql v-if="props.item.file" :file="props.item.file" />
            <span v-if="!props.item.file">{{ props.item.fileid }}</span>
          </td>
          <td>{{ props.item.tracker }}</td>
          <td>{{ props.item.special }}</td>
          <td>
            <EntityZ
              v-if="props.item.user"
              :entity="props.item.user"
              format="system"
            />
            <span v-if="!props.item.user">{{ props.item.userid }}</span>
          </td>
          <td>
            <span v-if="props.item.customdate">{{
              props.item.customdate | formatDateTime
            }}</span>
            <span v-else>{{ props.item.timestamp | formatDateTime }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-alert v-if="bills && bills.length == 0" :value="true" type="info"
      >No bills found</v-alert
    >
    <v-progress-circular indeterminate color="info" v-if="!bills" />
  </div>
</template>

<script>
import BILLS from "@/graphql/accounts/bill/Bills";
import FIX_FUNDVIEW_PROBLEM from "@/graphql/accounts/bill/FixFundviewProblem";
import EntityZ from "@/components/link/EntityZ";
import FileGql from "@/components/link/FileGql";
export default {
  name: "BillDiary",
  metaInfo() {
    return {
      title: "Bill diary",
      titleTemplate: "%s - Accounts - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    bills: {
      query: BILLS,
      variables() {
        return {
          date: this.computedDate
        };
      },
      fetchPolicy: "cache-and-network"
    }
  },
  components: {
    EntityZ,
    FileGql
  },
  computed: {
    computedDate() {
      return this.$route.query.date
        ? this.$route.query.date.substring(0, 4) +
            "-" +
            this.$route.query.date.substring(4, 6) +
            "-" +
            this.$route.query.date.substring(6, 8)
        : new Date().toISOString().substr(0, 10);
    }
  },
  data() {
    return {
      bills: [],
      files: null,
      entities: null,
      headers: [
        {
          text: "id",
          value: "id"
        },
        {
          text: "billprojection",
          value: "billprojection"
        },
        {
          text: "file",
          value: "file.id"
        },
        {
          text: "tracker",
          value: "tracker"
        },
        {
          text: "special",
          value: "special"
        },
        {
          text: "user",
          value: "user.name"
        },
        {
          text: "timestamp",
          value: "timestamp"
        }
      ],
      pagination: {
        rowsPerPage: -1
      }
    };
  },
  methods: {
    async fixFundviewProblem() {
      await this.$apollo.mutate({
        mutation: FIX_FUNDVIEW_PROBLEM,
        refetchQueries: [
          {
            query: BILLS,
            variables: { date: this.computedDate }
          }
        ]
      });
    }
  }
};
</script>
